module.exports = __webpack_public_path__ + "img/lightmode_daylight.911cac3c.png";